import axios from '@/services/axios-auth-wrapper';

export default {
    getSurveyXmlFileStateForSurvey: (surveyId) => {
        return axios.get(url + 'state/' + surveyId);
    },
    deleteSurveyXmlFile: (surveyId) => {
        return axios.delete(url + surveyId);
    },
    downloadSurveyXmlFile: (surveyId) => {
        return axios.get(url + surveyId + '/download', { responseType: 'blob' });
    }
};

const url = process.env.VUE_APP_INDIGO_API_URL + '/api/surveyxmlfile/';
